import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import PC from "../views/pc/pc.vue";
import News from "../views/pc/news.vue";
import List from "../views/pc/list.vue";
import Mobile from "../views/mobile/mobile.vue";
import MobileNews from "../views/mobile/news.vue";
import MobileList from "../views/mobile/list.vue";
import CallBack from "../views/callback.vue";

const routes = [
  {
    path: "/",
    component: PC,
  },
  {
    path: "/news",
    component: News,
  },
  {
    path: "/list",
    component: List,
  },
  {
    path: "/mobile",
    component: Mobile,
  },
  {
    path: "/mobile/news",
    component: MobileNews,
  },
  {
    path: "/mobile/list",
    component: MobileList,
  },
  {
    path: "/callback",
    component: CallBack,
  },
];

const router = createRouter({
  history: createWebHashHistory(), //createWebHistory
  routes,
});

export default router;
